<script>
export default {
  functional: true,
  name: 'KwGradient',
  render(h, context) {
    return h(
      'div',
      {
        class: 'kw-gradient',
        slot: context.data.slot,
      },
      context.slots().default,
    );
  },
};
</script>

<style lang="scss" scoped>
  .kw-gradient {
    background-image: linear-gradient(to left, #f6f7f8, #e3e7e9 50%, #f6f7f8);
    width: 100%;
    height: 100%;
    animation: Gradient 2s ease infinite;
  }
  @keyframes Gradient {
    0% {
      background-position: 0px;
    }
    50% {
      background-position: 50px;
    }
    100% {
      background-position: 0px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/KwGradient.vue